// Helpers to keep per-route SEO head tags in sync (canonical + og:*).
const SITE = "https://www.freecrm.com";

function upsertMeta(selector: string, attr: "name" | "property", key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(selector);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export function setSeoHead({
  title,
  description,
  path,
  noindex = false,
}: {
  title: string;
  description: string;
  /** Omit (with noindex) on error pages so the broken URL is never declared canonical. */
  path?: string;
  noindex?: boolean;
}) {
  document.title = title;

  const desc = document.head.querySelector<HTMLMetaElement>('meta[name="description"]');
  if (desc) desc.setAttribute("content", description);

  const robots = document.head.querySelector<HTMLMetaElement>('meta[name="robots"]');
  let canonical = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');

  if (noindex || path === undefined) {
    canonical?.remove();
    upsertMeta('meta[name="robots"]', "name", "robots", "noindex");
    upsertMeta('meta[property="og:title"]', "property", "og:title", title);
    upsertMeta('meta[property="og:description"]', "property", "og:description", description);
    upsertMeta('meta[name="twitter:title"]', "name", "twitter:title", title);
    upsertMeta('meta[name="twitter:description"]', "name", "twitter:description", description);
    return;
  }
  // Client-side navigation reuses the same head, so undo a prior 404 view's noindex.
  robots?.remove();

  const url = `${SITE}${path}`;

  if (!canonical) {
    canonical = document.createElement("link");
    canonical.setAttribute("rel", "canonical");
    document.head.appendChild(canonical);
  }
  canonical.setAttribute("href", url);

  upsertMeta('meta[property="og:url"]', "property", "og:url", url);
  upsertMeta('meta[property="og:title"]', "property", "og:title", title);
  upsertMeta('meta[property="og:description"]', "property", "og:description", description);
  upsertMeta('meta[name="twitter:title"]', "name", "twitter:title", title);
  upsertMeta('meta[name="twitter:description"]', "name", "twitter:description", description);
}
